import React, { useState } from "react";
import route from "@/shared/ziggy/route";

const CookieAlertDom = () => {
  const [show, setShow] = useState(true);
  const privacyPolicyLink = route("user.privacypolicy.index");

  if (!show) {
    return <></>;
  }
  return (
    <div className="l-cookie-alert">
      <p className="l-cookie-alert__txt">
        <span className="l-cookie-alert__title">Cookieの利用について</span>
        当サイトはサービス向上のためCookieを利用しております。以降ページ遷移した場合は、Cookie利用に同意したことになります。
        <a className="l-cookie-alert__link" href={privacyPolicyLink}>
          詳しくはこちら
        </a>
      </p>
      <span
        id="js-cookie_close"
        className="l-cookie-alert__close icon_close"
        onClick={() => setShow(false)} // 閉じるボタンを押したらアラートを非表示
      ></span>
    </div>
  );
};

export default CookieAlertDom;
